<template>
 
  <div class="space-y-0 w-[900px]">

    <ModalSolicitudDet
      :centro_id="centro_id"
      :nomcentro="nomcentro"
      :nomcta="nomcta"
      :visible="visibleSolicitudDet"
      :datosSolicitud="datosSolicitud"
      :timestamp="timestamp" 
      :idSolicitudEdit="idSolicitudEdit"
      @update:visible="visibleSolicitudDet = $event"
      @get_monto_mensual="set_monto_mensual"
      @recarga_solicitudes="lee_presupuesto_borrador"/>

    <ModalSolicitud
      :visible="visibleSolicitud"
      :datos="datos"
   
      @update:visible="visibleSolicitud = $event"
      @get_solicitud="set_solicitud"/>

  
    <!-- Total 
    <div class="text-gray-900 font-medium mb-4">
      
      <span class="text-gray-900 font-medium">{{ total_presupuesto }}</span>
    </div>-->

    <!-- Título sección -->
    <div class="flex justify-between">
      <span class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">&lt;IngresosMensualesBorrador&gt;</span>
 
      <span class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">/api/v1/ingresos/presupuesto/borrador/centro/x/cuenta/y/</span>
    </div>
 
  <div   class="  flex items-center justify-between px-3 py-4 mb-1 rounded-t-2xl bg-gradient-to-r from-indigo-100 to-gray-100 text-black shadow-md">
    <div class="ml-0 grid grid-cols-4 sm:grid-cols-4 gap-1 text-sm">
    <div> 
      <button  
      
          @click="showmodalSolicitud"
          class="flex items-center justify-center  p-2 
                bg-green-600 text-white text-sm   shadow
                hover:bg-green-400  hover:shadow-md
                transition duration-150 font-mono  rounded-2xl"  > + Añadir item a presupuesto {{ this.$store.state.auth.userLogin.año_borrador }}    
 
        </button> 
    </div>
    <div class="text-left ml-3 mt-1">
          <div class="text-xs text-gray-500 uppercase tracking-wide mt-1">
             Cuenta
          </div>
          <div class="text-gray-900   font-mono">{{ nomcta }}</div>

    </div>

    <div class="text-left mt-1">
        
          <div class="text-xs text-gray-500 uppercase tracking-wide mt-1">
            Presupuesto {{ this.$store.state.auth.userLogin.año_borrador }} 
          </div>
          
          <div class="text-gray-900   font-mono">
            $ {{ $formatoMiles(this.total_presupuesto_borrador) }} 
          </div>
    </div>
    <div> 
      <div  v-if="loading"  class=" rounded  cursor-pointer w-6 h-6 mx-auto border-4 border-gray-300 border-t-blue-600 rounded-full animate-spin"></div>
    </div>

  </div>
 </div>
    
    <!-- Contenedor principal -->
    <div class="p-5 bg-gray-100 rounded-b-xl shadow-md border border-gray-200">
 
      <ListaSolicitudes  
      :propSolicitudes="solicitudes" 
      @recarga_solicitudes="lee_presupuesto_borrador"
      @set_idSolicitudEdit="set_idSolicitudEdit"/>
   
    </div>
  </div>
</template>

<script>
 
import ModalSolicitudDet from "./ModalSolicitudDet.vue";
import ModalSolicitud from "./ModalSolicitud.vue";
 
import api from "@/api/axios";
import ListaSolicitudes from "./ListaSolicitudes.vue";


export default {
  emits: ["toggleCuentaBorrador","getApiPresupuesto","devuelve_total"],
  props: {
    cuenta_total_presupuesto_aa_abierto:{
        type: Number,
    },
    nomcta: {
      type: String,
    },
    nomcentro: {
      type: String,
    },
    centro_id: {
      type: Number,
    },
    propCuenta_id: {
      type: Number,
    },

    datosFromModalIngreso: {
      type: Object,
    },
    componenteVisible: {
      type: Boolean,
    },
     propReloadMovimientosMensuales:{
      type:Number
    }
  },
  data() {
    return {
      visibleIngreso: false,
      visibleSolicitudDet: false,
      visibleSolicitud: false,
      idSolicitudEdit: 0,
      solicitudes: [],
 
     
      total_presupuesto: 0,
      mes: 0,
      meses: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Sept",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ],
      monto_mensual: [],
      monto_modif_mensual_suma: [],
      monto_modif_mensual_resta: [],
      presupuesto_mensual: [],
      loading: false,
      dataModalIngreso: {},
      datosIngreso: {},
      datos: {},
      datos_historial:{},
      timestamp: "",
      visibleHistorial: false,
      datosSolicitud:{},
      reloadMovimientosMensuales:'',
      polling:'',
      visibleModal:false,
      cuenta_id:this.propCuenta_id ,
      total_presupuesto_borrador:0,
    
    };
  },
  methods: {
    
     showmodalSolicitud() {
       this.datos = {
          nomcta: this.nomcta,
          nomcentro: this.nomcentro,
      
        };
      this.visibleSolicitud = true;
    },
  
    async llenavalores() 
    {
      
      this.recalcular_totales(  );

      
      
    },

    recalcular_totales( )
    {
       return true;
    },

    set_monto_mensual() {
      console.log("recarga valores");
      this.llenavalores();
    },
    
    set_solicitud(obj) 
    {
     
          
            this.datosSolicitud.descripcion_solicitud= obj.descripcion_solicitud;
            this.datosSolicitud.monto_solicitud=obj.monto_solicitud;
            this.timestamp = new Date().toISOString().slice(0, 19).replace("T", " "); // crear string timestamp
            this.idSolicitudEdit=0
            this.visibleSolicitudDet = true;
  
      
    },
    set_idSolicitudEdit(id){
      console.log('v',id)
      this.idSolicitudEdit = id;
      this.visibleSolicitudDet=true;
    },
   async lee_presupuesto_borrador(){
     
      try{
        
       this.loading=true;
       const resp = await api.get(
          `/api/v1/ingresos/presupuesto/borrador/centro/${this.centro_id}/cuenta/${this.cuenta_id}/`,
           { headers: { "Content-Type": "application/json"  } }
        );
        const status = resp.data.status;
        switch (status) {
          case 200:
            this.total_presupuesto_borrador = resp.data?.total_presupuesto;
            this.solicitudes = resp.data?.solicitudes
           
            this.datosSolicitud = {
              "presupuesto_id": resp.data?.presupuesto_id,
              "cuenta_total_presupuesto_aa_abierto":this.cuenta_total_presupuesto_aa_abierto,
              "cuenta_total_presupuesto_aa_borrador":this.total_presupuesto_borrador,
 
              "centro_id": this.centro_id,
              "cuenta_id": this.cuenta_id,
              "accion_id":1,
              "ingresos": resp.data?.ingresos
              
            }
            this.timestamp = new Date().toISOString().slice(0, 19).replace("T", " "); // crear string timestamp
            this.loading=false;
            this.$emit('devuelve_total',{'cuenta_id': this.cuenta_id,'total':this.total_presupuesto_borrador})
            break;
          default:
            console.error(status);
        }
       
      } catch (err) {
        console.log(err);
      } 


     
    },
    
    formatoMiles(num) {
      return Number(num).toLocaleString("es-CL", {
        minimumFractionDigits: 1,
        maximumFractionDigits: 2,
      });
    },
   
  },
  mounted() {
 
    this.cuenta_id=this.propCuenta_id;
    this.llenavalores();
     
  },
   
  components: {
 
    ModalSolicitudDet,
    ModalSolicitud,
    ListaSolicitudes
  },
  watch: {
      componenteVisible: {
      handler(val) {
        if (val) {
          this.lee_presupuesto_borrador();
          this.llenavalores();
        }
      },
      immediate: true
    },
    propCuenta_id: {

      handler(val) {
        if (val) {
          this.cuenta_id = val;
        }
      },
      immediate: true
    },



    
    datosFromModalIngreso: function () {},
     
  },
    beforeUnmount() {
    clearInterval(this.polling);
  },
  
};
</script>
